import { IconContent } from '@icons';

export const locationsFilled: IconContent = {
    md: '<path fill-rule="evenodd" d="M12 20.75c4.5-2.5 7-6.634 7-10.5a7 7 0 1 0-14 0c0 3.866 2.5 8 7 10.5ZM12 12a2 2 0 1 0 0-4 2 2 0 0 0 0 4Z" />',
};
